<template>
  <section class="position-relative">
    <div class="control-menu">
      <div class="d-flex justify-content-end align-items-end bg-white gap-3 p-2 mb-3" style="gap:1rem">
        <div><b-button variant="success" @click="$router.go(-1)">Back</b-button></div>
      </div>
    </div>
    <b-card >
      <h6>Update Price by Quantity</h6>
      <div class="d-flex bg-white gap-3 p-2 mb-3" style="gap:1rem">
        <div><b-form-input type="number" placeholder="Enter quantity" v-model="quantity"></b-form-input></div>
        <div><b-form-input type="number" placeholder="Enter Margin" v-model="margin"></b-form-input></div>
        <div><b-button variant="success" :disabled="!quantity || !margin || loading" @click="updateByQuenty">{{ loading
          ? 'Updating...' : 'Save' }}</b-button></div>
      </div>
      <h6>Reset Price :</h6>
      <p>The price will be reset to the default price, if your  price is 10 for 1 quantity then the price will be 10*Quantity</p>
      <b-button variant="warning" :disabled="loading" @click="resetPrice">Reset Price</b-button>
    </b-card>
    <b-card v-for="(item, index) in varients" :key="index">
      <div class="row g-4">
        <div class="col-4 bg-light p-3">
          <table>
            <tbody>
              <tr v-for="option in item.option_values" :key="option.id">
                <th class="pr-3">{{ option.option.name }}:</th>
                <td>{{ option.value.name }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-8">
          <table>
            <thead>
              <tr>
                <th>Quantity</th>
                <th>Express</th>
                <th>Standard</th>
                <th>Value</th>
                <th>Margin</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(price, i) in item.prices" :key="i" style="vertical-align: top;">
                <td><b-form-input type="number" :class="{'border-success': price.is_updated}" v-model="price.quantity"></b-form-input></td>
                <td class="d-flex gap-1 flex-column"><b-form-input type="number" :class="{'border-success': price.is_updated}" v-model="price.express" @blur="updatePrice(price)"></b-form-input> <span class="text-danger">{{ (price.express/price.quantity).toFixed(2) }}</span></td>
                <td><b-form-input type="number" :class="{'border-success': price.is_updated}" v-model="price.standard" @blur="updatePrice(price)"></b-form-input><span class="text-danger">{{ (price.standard/price.quantity).toFixed(2) }}</span></td>
                <td><b-form-input type="number" :class="{'border-success': price.is_updated}" v-model="price.value" @blur="updatePrice(price)"></b-form-input><span class="text-danger">{{ (price.value/price.quantity).toFixed(2) }}</span></td>
                <td class="d-flex gap-1"><b-form-input type="number" :class="{'border-success': price.is_updated}" v-model="price.margin"></b-form-input> <b-button
                    variant="success" @click="updateSinglePrice(price, index)">{{ updatingId == price.id ? 'Updating...' : 'Save' }}</b-button></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-card>
  </section>
</template>

<script>

export default {
  data() {
    return {
      varients: null,
      quantity: null,
      margin: null,
      standardMargin: null,
      loading: false,
      updatingId: null
    };
  },
  mounted() {
    this.getvariant();
  },
  methods: {
    getvariant() {
      let loader = this.$loading.show({
        loader: "dots",
      });
      this.$store.getters.client
        .post(`variant/get-variant/`, { product_id: this.id })
        .then((response) => {
          this.varients = response.data.data.variants;
          this.varients.forEach((item) => {
            item.prices = item.prices.map((price) => ({
              ...price,
              margin: 10,
              is_updated: false
            }))
          })
          loader.hide();
        })
        .catch((error) => {
          console.log(error);
          loader.hide();
        });
    },
    async updateSinglePrice(priceItem, index) {
      this.updatingId = priceItem.id
      const data = {
        express_price: ((100 + Number(priceItem.margin)) * Number(priceItem.express) / 100).toFixed(2),
        standard_price: ((100 + Number(priceItem.margin)) * Number(priceItem.standard) / 100).toFixed(2),
        value_price: ((100 + Number(priceItem.margin)) * Number(priceItem.value) / 100).toFixed(2),
        quantity: Number(priceItem.quantity),
      }
      try {
        await this.$store.getters.client.put(`variant/update-variant/${priceItem.id}`, data);
        const findedPrice = this.varients[index].prices.find((item) => item.id == priceItem.id)
        findedPrice.express = data.express_price
        findedPrice.standard = data.standard_price
        findedPrice.value = data.value_price
        findedPrice.is_updated = true
      } catch (error) {
        alert("price not updated");
      } finally {
        this.updatingId = null
      }
    },
    updatePrice(priceItem) {
      const data = {
        express_price: Number(priceItem.express),
        standard_price: Number(priceItem.standard),
        value_price: Number(priceItem.value),
        quantity: Number(priceItem.quantity),
      };
      let loader = this.$loading.show({
        loader: "dots",
      });
      try {
        this.$store.getters.client.put(`variant/update-variant/${priceItem.id}`, data);
      } catch (error) {
        alert("price not updated");
      } finally {
        loader.hide();
      }
    },
    async updateByQuenty() {
      this.loading = true;
      try {
        let count = 0;
        const interval = setInterval(async () => {
          if (count >= this.varients.length) {
            clearInterval(interval);
            this.loading = false;
            return;
          }
          const element = this.varients[count];
          const prices = element.prices.find((item) => item.quantity == this.quantity);
          const data = {
            express_price: ((100 + Number(this.margin)) * Number(prices.express) / 100).toFixed(2),
            standard_price: ((100 + Number(this.margin)) * Number(prices.standard) / 100).toFixed(2),
            value_price: ((100 + Number(this.margin)) * Number(prices.value) / 100).toFixed(2),
            quantity: Number(this.quantity),
          }
           await this.$store.getters.client.put(`variant/update-variant/${prices.id}`, data);
          const findedPrice = element.prices.find((item) => item.quantity == this.quantity);
          findedPrice.express = data.express_price;
          findedPrice.standard = data.standard_price;
          findedPrice.value = data.value_price;
          findedPrice.margin = this.margin;
          findedPrice.is_updated = true
          count++;
        }, 1000);
      } catch (error) {
        alert("price not updated");
        this.loading = false;
      }
    },
    async resetPrice() {
      this.loading = true;
      for (let i = 0; i < this.varients.length; i++) {
        const element = this.varients[i];
        const unitPrice = element.prices[0];
        for (let j = 0; j < element.prices.length; j++) {
          const data = {
            express_price: ((element.prices[j].quantity/unitPrice.quantity) * unitPrice.express).toFixed(2),
            standard_price: ((element.prices[j].quantity/unitPrice.quantity) * unitPrice.standard).toFixed(2),
            value_price: ((element.prices[j].quantity/unitPrice.quantity) * unitPrice.value).toFixed(2),
            quantity: element.prices[j].quantity
          }
          try {
            await this.$store.getters.client.put(`variant/update-variant/${element.prices[j].id}`, data);
            const findedPrice = element.prices.find((item) => item.quantity == data.quantity);
            findedPrice.express = data.express_price;
            findedPrice.standard = data.standard_price;
            findedPrice.value = data.value_price;
          } catch (error) {
            alert("price not updated");
          }
        }
      }
      this.loading = false;
    },
    calculatePrice(index, i, amount) {
      this.varients[index].prices[i].express = (Number(amount) * Number(this.expressMargin) / 100) + Number(amount)
      this.varients[index].prices[i].standard = (Number(amount) * Number(this.standardMargin) / 100) + Number(amount)
    }
  },
  created() {
    this.id = this.$route.params.id;
  },
};
</script>

<style scoped>
.control-menu {
  position: sticky;
  top: 100px;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;

}
</style>